<div class="pl-pane__container--horizontal pl-pane--full-screen">

  <div class="pl-pane__container--horizontal pl-pane--full-screen">
    <app-ngin-iframe
      *ngIf="loginBasePath"
      [path]="surveyResultUrl"
      [domain]="loginBasePath">
    </app-ngin-iframe>
  </div>

</div>
